import React from 'react';

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import Collapse from '@material-ui/core/Collapse';
import Slide from '@material-ui/core/Slide';

import { write,read } from '../../utils/localStorageUtils';
import { deleteCache, saveToCache,setImgFromCache,getFromCache } from '../../utils/cacheUtils';
import { BannerIklan, MiniIklan } from '.';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const tax=0

const DialogNewAds=React.memo((props)=>{
  const {
    open,
    onClose,
    firebase,
    //currentUser,
    isMobile=false,
    authUser,
  }=props

  //const {runOnMobile: isMobile}=usePWA()

  const [step,setStep]=React.useState(0)
  const [uploading,setUploading]=React.useState(false)
  
  const imgRef=React.useRef()
  const [pathCache,setPathCache]=React.useState("")
  const [imageText,setImageText]=React.useState("Upload Foto")

  const [newDocId,setNewDocId]=React.useState("")
  const [outstandingReviewAds,setOutstandingReviewAds]=React.useState()
  const [outstandingPurchaseAds,setOutstandingPurchaseAds]=React.useState()
  const [ownedLiveAds,setOwnedLiveAds]=React.useState()
  

  const [name,setName]=React.useState("")
  const [description,setDescription]=React.useState("")
  const [enableLink, setEnableLink] = React.useState(false);
  const [linkValue,setLinkValue]=React.useState("")
  const [enableWhatsapp, setEnableWhatsapp] = React.useState(false);
  const [whatsappValue,setWhatsappValue]=React.useState("")
  const [enableMarketName, setEnableMarketName] = React.useState(false);
  const [marketNameValue,setMarketNameValue]=React.useState("")
  const [price,setPrice]=React.useState("")
  const [imageURL,setImageURL]=React.useState("")
  const [thumb_photoURL,setThumb_photoURL]=React.useState("")
  const [statusReviewAds,setStatusReviewAds]=React.useState("Ditinjau")


  const [quotaView,setQuotaView]=React.useState(200)
  const [pricePerView,setPricePerView]=React.useState(500)
  const [buyerName,setBuyerName]=React.useState("")
  const [buyerEmail,setBuyerEmail]=React.useState("")
  const [purchaseAmount,setPurchaseAmount]=React.useState(0)

  const [discount,setDiscount] = React.useState(0)

  const [readTos1,setReadTos1]=React.useState(false)
  const [readTos2,setReadTos2]=React.useState(false)

  const imgBuktiBayarRef=React.useRef()
  const [imageBuktiBayarText,setImageBuktiBayarText]=React.useState("Upload Bukti Bayar")
  const [updatedImageChache,setUpdatedImageChache]=React.useState(false)

  const hasChange=React.useMemo(()=>{
    if(!outstandingReviewAds || updatedImageChache) return true
    
    return outstandingReviewAds.name !== name ||
    outstandingReviewAds.description !== description ||
    outstandingReviewAds.purchaseURL !== (enableLink?linkValue:"") ||
    outstandingReviewAds.sellerPhone !== (enableWhatsapp?whatsappValue:"") ||
    outstandingReviewAds.sellerName !== (enableMarketName?marketNameValue:"") ||
    outstandingReviewAds.purchasePrice !== (parseInt(price)||0) ||
    outstandingReviewAds.photoURL !== imageURL ||
    outstandingReviewAds.thumb_photoURL !== thumb_photoURL ||

    outstandingReviewAds.pricePerView !== pricePerView ||
    outstandingReviewAds.userId !== authUser?.uid

  },[outstandingReviewAds,name,description,enableLink,linkValue,enableWhatsapp,whatsappValue,
    enableMarketName,marketNameValue,price,imageURL,thumb_photoURL,pricePerView,authUser,updatedImageChache])
  

  React.useEffect(()=>{
    setPathCache(read("cariiklan.newAdsImageURL"))
    setNewDocId(read("cariiklan.newAdsDocId"))
  },[])

  React.useEffect(()=>{
    if(open){
      setStep(0)
    }
  },[open])

  //Get live Ads
  React.useEffect(()=>{
    if(!firebase||!authUser)return
    
    let query=firebase.fs.collection("apps/CariIklan/live-ads")
    query=query.where("userId","==",authUser.uid).limit(1)
    return query.onSnapshot((querySnapshot) => {
      var ownedLiveAds = [];
      querySnapshot.forEach((doc) => {
          ownedLiveAds.push(doc.data());
      });
      setOwnedLiveAds(ownedLiveAds[0])
    },e=>{
      setOwnedLiveAds(null)
      console.log("error get ownedLiveAds",e)
    });
  },[firebase,authUser])

  //Get ongoing review Ads
  React.useEffect(()=>{
    if(!firebase||!authUser)return
    
    let query=firebase.fs.collection("apps/CariIklan/review-ads")
    query=query.where("status","!=","Aktif")
    query=query.where("userId","==",authUser.uid).limit(1)
    return query.onSnapshot((querySnapshot) => {
      var outstandingReviewAds = [];
      querySnapshot.forEach((doc) => {
          outstandingReviewAds.push(doc.data());
      });
      setOutstandingReviewAds(outstandingReviewAds[0])
      console.log("outstandingReviewAds = "+outstandingReviewAds.length)
    },e=>{
      setOutstandingReviewAds(null)
      console.log("error get outstandingReviewAds",e)
    });
  },[firebase,authUser])

  //Get ongoing purchase Ads from review Ads
  React.useEffect(()=>{
    if(!firebase||!outstandingReviewAds)return
    
    let query=firebase.fs.collection("apps/CariIklan/purchases")
    query=query.where("id","==",outstandingReviewAds.id).limit(1)
    return query.onSnapshot((querySnapshot) => {
      var outstandingPurchaseAds = [];
      querySnapshot.forEach((doc) => {
          outstandingPurchaseAds.push(doc.data());
      });
      setOutstandingPurchaseAds(outstandingPurchaseAds[0])
      console.log("outstandingPurchaseAds = "+outstandingPurchaseAds.length)
    },e=>{
      setOutstandingPurchaseAds(null)
      console.log("error get outstandingPurchaseAds",e)
    });
  },[outstandingReviewAds,firebase])

  

  React.useEffect(()=>{
    if(!!outstandingReviewAds){
      setName(outstandingReviewAds.name)
      setDescription(outstandingReviewAds.description)
      setEnableLink(!!outstandingReviewAds.purchaseURL)
      setLinkValue(outstandingReviewAds.purchaseURL)
      setEnableWhatsapp(!!outstandingReviewAds.sellerPhone)
      setWhatsappValue(outstandingReviewAds.sellerPhone)
      setEnableMarketName(!!outstandingReviewAds.sellerName)
      setMarketNameValue(outstandingReviewAds.sellerName)
      setPrice(outstandingReviewAds.purchasePrice)
      setImageURL(outstandingReviewAds.photoURL)
      setThumb_photoURL(outstandingReviewAds.thumb_photoURL)
      setStatusReviewAds(outstandingReviewAds.status)

      setImageText("")
    }
  },[outstandingReviewAds])

  React.useEffect(()=>{
    if(open){
      if(!!outstandingPurchaseAds){
        setBuyerEmail(outstandingPurchaseAds.customerEmail)
      }else{
        setBuyerEmail(authUser?.email)
      }
    }
  },[authUser,open,outstandingPurchaseAds])

  React.useEffect(()=>{
    setDiscount(!!authUser&&!ownedLiveAds&&!outstandingPurchaseAds?100000:0)
  },[authUser,ownedLiveAds,outstandingPurchaseAds])

  React.useEffect(()=>{
    if(!!outstandingPurchaseAds){
      setQuotaView(outstandingPurchaseAds.purchasedView)
      setPricePerView(outstandingPurchaseAds.pricePerView)
      setBuyerName(outstandingPurchaseAds.customerName)
      setBuyerEmail(outstandingPurchaseAds.customerEmail)
      setPurchaseAmount(outstandingPurchaseAds.paymentAmount)
      setDiscount(outstandingPurchaseAds.discount)

      setReadTos1(true)
      setReadTos2(true)

      setImageBuktiBayarText(!!outstandingPurchaseAds.paymentURL?"":(outstandingPurchaseAds.billableAmount<=0?"Tidak perlu ":"")+"Upload Bukti Bayar")
    }
  },[outstandingPurchaseAds])

  

  
  //apply foto iklan setImageURL
  React.useEffect(()=>{
    if(!open)return
    if(imageURL.startsWith("/")){
      //load cache
      setImgFromCache(imageURL,imgRef,()=>{
        setImageText("")
      },(e)=>{
        setImageText("Upload Foto")
        console.log("error",e)
      })
    }else if(imageURL.startsWith("http")){
      //load from URL
      if(!!imgRef.current) imgRef.current.src=imageURL
    }else{
      if(!!imgRef.current) imgRef.current.src="/static/no-image.png"
    }
  },[imageURL,open])

  //ambil foto iklan
  React.useEffect(()=>{
    if(open&&!!firebase){
      if(!!outstandingReviewAds){
        //dari outstanding purchases
        setImageURL(outstandingReviewAds.photoURL)
        setNewDocId(outstandingReviewAds.id)
      }else if(!!pathCache){
        //dari upload an sebelumnya
        setImageURL(pathCache)
        
      }else{
        //belum ada foto
        var newReviewAds = firebase.fs.collection("apps/CariIklan/review-ads").doc();
        setNewDocId(newReviewAds.id)
        write("cariiklan.newAdsDocId",newReviewAds.id)

        //setImageURL("/apps/CariIklan/review-ads/"+newReviewAds.id)
      }
    }
  },[open,firebase,pathCache,outstandingReviewAds])

  

  //Ubah Photo iklan
  const handlePhotoChange=React.useCallback((ev)=>{

    if(!!outstandingPurchaseAds&&outstandingPurchaseAds.status==="Ditinjau")return
    //if(outstandingPurchaseAds?.contentStatus==="Ditinjau"||outstandingPurchaseAds?.contentStatus==="Aktif")return

    var fileObj=ev.target.files[0]
    if(!fileObj)return

    if(fileObj.size>=1024*1024*10){
      alert("Maaf, ukuran file tidak boleh melebihi 10MB !")
      setImageText("Maaf, ukuran file tidak boleh melebihi 10MB !")
      return
    }

    let imageCacheURLStorage="/apps/CariIklan/review-ads/"+newDocId

    saveToCache(imageCacheURLStorage,fileObj,()=>{
      
      setImageURL(imageCacheURLStorage)
      setUpdatedImageChache(true)
      //console.log("setImageURL = "+imageCacheURLStorage)

      write("cariiklan.newAdsImageURL",imageCacheURLStorage)
      setPathCache(imageCacheURLStorage)

      setImgFromCache(imageCacheURLStorage,imgRef,()=>{
        setImageText("")
      },(e)=>{
        setImageText("Gagal Upload Foto, coba lagi")
        console.log("error",e)
      })
    })
    ev.target.value=null
  },[newDocId,outstandingPurchaseAds])



   //ambil dan apply foto bukti bayar
   React.useEffect(()=>{
    if(!open)return
    //console.log("effect outstandingPurchaseAds?.paymentURL = "+(outstandingPurchaseAds?.paymentURL))
    if(outstandingPurchaseAds?.paymentURL?.startsWith("/")){
      //load cache
      setImgFromCache(outstandingPurchaseAds.paymentURL,imgBuktiBayarRef,()=>{
        setImageBuktiBayarText("")
      },(e)=>{
        setImageBuktiBayarText((outstandingPurchaseAds.billableAmount<=0?"Tidak perlu ":"")+"Upload Bukti Bayar")
        console.log("error",e)
      })
    }else if(outstandingPurchaseAds?.paymentURL.startsWith("http")){
      //load from URL
      if(!!imgBuktiBayarRef.current) imgBuktiBayarRef.current.src=outstandingPurchaseAds.paymentURL
    }else{
      if(!!imgBuktiBayarRef.current) imgBuktiBayarRef.current.src="/static/no-image.png"
    }
  },[outstandingPurchaseAds,open])

  //Ubah Bukti Bayar
  const handleBuktiBayarChange=React.useCallback((ev)=>{
    if(!outstandingPurchaseAds)return
    if(outstandingPurchaseAds.status==="Ditinjau"||outstandingPurchaseAds.status==="Aktif")return

    var fileObj=ev.target.files[0]
    if(!fileObj)return

    if(fileObj.size>=1024*1024*10){
      alert("Maaf, ukuran file tidak boleh melebihi 10MB !")
      setImageBuktiBayarText("Maaf, ukuran file tidak boleh melebihi 10MB !")
      return
    }

    setUploading(true)

    let promiseUpload=[fileObj].map(d=>new Promise((res,rej)=>{
      uploadImageToStorage(
        firebase,
        d,
        "/apps/CariIklan/purchases/"+outstandingPurchaseAds.id,
        "paymentURL",
        false,
      ).then(obj=>res(obj))
      .catch(e=>{
        console.log("Upload blob "+d.id+" error",e)
        rej(e)
      })
    }))
    

    Promise.allSettled(promiseUpload)
    .then((results) =>{
      let failCount=0
      results.forEach((result) => failCount+=result.status==="rejected"?1:0)
      if(failCount>0){
        alert("Upload gagal "+failCount+" foto\n\n"+results.map((result,i) => (i+1)+" "+ result.status +", "+result.reason+"\n"))
        setImageBuktiBayarText("Upload gagal")
        setUploading(false)
        return
      }

      let downloadURL=results[0].value?.downloadURL

      var batch = firebase.fs.batch();

      var purchaseRef = firebase.fs.doc("apps/CariIklan/purchases/"+outstandingPurchaseAds.id)

      outstandingPurchaseAds.paymentURL=downloadURL
      outstandingPurchaseAds.status="Ditinjau"
      
      batch.set(purchaseRef, outstandingPurchaseAds);

      batch.commit()
      .then(() => {
        setImageBuktiBayarText("")
        setUploading(false)
      }).catch((e)=>{
        alert(e)
        setImageBuktiBayarText("Upload gagal "+e.message)
        setUploading(false)
      })
    }).catch(e=>{
      setUploading(false)
      setImageBuktiBayarText("Upload gagal "+e.message)
    })

    ev.target.value=null
  },[firebase,outstandingPurchaseAds])

  const handleChangeName = React.useCallback((ev) => {
    setName(ev.target.value );
  },[])
  const handleChangePrice = React.useCallback((ev) => {
    setPrice(ev.target.value );
  },[])
  const handleChangeDescription = React.useCallback((ev) => {
    setDescription(ev.target.value );
  },[])
  const handleChangeBuyerName = React.useCallback((ev) => {
    setBuyerName(ev.target.value );
  },[])
  const handleChangeBuyerEmail = React.useCallback((ev) => {
    setBuyerEmail(ev.target.value );
  },[])
  const handleChangePurchaseAmount = React.useCallback((ev) => {
    setPurchaseAmount(ev.target.value );
  },[])

  const handleChangeSwitchLink = React.useCallback((ev) => {
    setEnableLink(ev.target.checked );
  },[])
  const handleChangeLinkValue = React.useCallback((ev) => {
    setLinkValue(ev.target.value );
  },[])

  const handleChangeSwitchWhatsapp = React.useCallback((ev) => {
    setEnableWhatsapp(ev.target.checked );
  },[])
  const handleChangeWhatsappValue = React.useCallback((ev) => {
    setWhatsappValue(ev.target.value );
  },[])

  const handleChangeSwitchMarketName = React.useCallback((ev) => {
    setEnableMarketName(ev.target.checked );
  },[])
  const handleChangeMarketNameValue = React.useCallback((ev) => {
    setMarketNameValue(ev.target.value );
  },[])

  const handleChangePricePerView=React.useCallback((ev)=>{
    setPricePerView(parseInt(ev.target.value))
  },[])

  const handleChangeQuotaView=React.useCallback((ev)=>{
    setQuotaView(parseInt(ev.target.value))
  },[])

  const handleChangeTOS1=React.useCallback((ev)=>{
    setReadTos1(ev.target.checked)
  },[])
  const handleChangeTOS2=React.useCallback((ev)=>{
    setReadTos2(ev.target.checked)
  },[])

  const handleClickDelete = React.useCallback((ev) => {
    let ok=window.confirm("Apakah Anda yakin untuk membatalkan penayangan iklan produk Anda?")
    if(!ok)return

    deleteCache(imageURL,()=>{
      write("cariiklan.newAdsImageURL","")
      write("cariiklan.newAdsDocId","")
      
      setStep(0)

      setPathCache("")
      setImageText("Upload Foto")

      setNewDocId("")

      setName("")
      setDescription("")
      setEnableLink(false)
      setLinkValue("")
      setEnableWhatsapp(false)
      setWhatsappValue("")
      setEnableMarketName(false)
      setMarketNameValue("")
      setPrice("")
      setImageURL("")
      
      setQuotaView(200)
      setPricePerView(500)
      setBuyerName("")
      setBuyerEmail("")
      setPurchaseAmount(0)

      setReadTos1(false)
      setReadTos2(false)

      setImageBuktiBayarText("Upload Bukti Bayar")

      if(!!onClose) onClose()
    },(e)=>{
      alert(e)
    })
  },[imageURL,onClose])


  let enableGoToRincian= !!name && 
      !!price && 
      (!enableMarketName||(enableMarketName&&!!marketNameValue)) &&
      (enableWhatsapp||enableLink) &&
      (!enableWhatsapp||(enableWhatsapp&&!!whatsappValue)) &&
      (!enableLink||(enableLink&&!!linkValue))

  if(enableGoToRincian&&step===2){
    if(!buyerName||!buyerEmail||!readTos1||!readTos2)enableGoToRincian=false
  }

  

  const previewAds=React.useMemo(()=>{
    //if(!!outstandingReviewAds){
    //  return outstandingReviewAds
    //}else{
      return {
        id:newDocId,
        name,
        description,
        purchaseURL:enableLink?linkValue:"",
        sellerPhone:enableWhatsapp?whatsappValue:"",
        sellerName:enableMarketName?marketNameValue:"",
        purchasePrice:parseInt(price)||0,
        photoURL:updatedImageChache?pathCache:imageURL,//STEP 2
        thumb_photoURL:updatedImageChache?pathCache:thumb_photoURL,//STEP 2
  
        status:statusReviewAds,
        pricePerView,
        userId:authUser?.uid,
      }
    //}
  },[newDocId,name,description,enableLink,linkValue,
    enableWhatsapp,whatsappValue,enableMarketName,marketNameValue,price,pathCache,updatedImageChache,
    imageURL,pricePerView,authUser,thumb_photoURL,statusReviewAds
  ])

  const biaya=React.useMemo(()=>(parseInt(quotaView)||0) * (parseInt(pricePerView)||0)
  ,[quotaView,pricePerView])

  const discountValue = React.useMemo(()=>{
    //console.log("discounting",biaya,discount)
    if(discount<100){
      //console.log("apply discounting "+parseInt(biaya*discount/100))
      return parseInt(biaya*(discount)/100)
    }else{
      return discount
    }
  },[biaya,discount])
  
  const taxValue= React.useMemo(()=>{
    if(tax<100){
      return parseInt((biaya-discountValue)*tax/100)
    }else{
      return tax
    }
  },[biaya,discountValue])

  const totalTagihan = React.useMemo(()=>{
    //console.log("Counting",biaya,discountValue,taxValue)
    return (biaya-discountValue+taxValue)}
  ,[biaya,discountValue,taxValue])

  

  //if(!!outstandingPurchaseAds){
  //  purchaseAds=outstandingPurchaseAds
  //}
  

  const handlePrevStep = React.useCallback(() => {
    setStep(prev=>prev-1);
  },[])

  
  const handleNextStep = React.useCallback(() => {
    if(step===2){

      let statusPembelian="Menunggu Bukti Bayar"
      if(totalTagihan===0){
        statusPembelian="Ditinjau"
      }

      let purchaseAds={
        id:newDocId,
        purchasedView:quotaView,
        pricePerView:pricePerView,
        purchaseName:"Penayangan Iklan "+name,
        thumb_photoURL:imageURL,//STEP 2
        amount:biaya,
        discount,
        discountValue,
        tax,
        taxValue,
        billableAmount:totalTagihan,
        customerId:authUser?.uid,
        customerName:buyerName,
        customerEmail:buyerEmail,
        employeeId:"",// EMPLOYEE
        employeeName:"",// EMPLOYEE
        status:statusPembelian,// EMPLOYEE
        contentStatus:"Ditinjau",// EMPLOYEE
        paymentDate:0,// EMPLOYEE
        paymentAmount:parseInt(purchaseAmount)||0,// EMPLOYEE
        paymentMethod:"QRIS",
        paymentURL:"",//STEP 3 
        denial:"",// EMPLOYEE
        purchaseDate:(new Date().getTime()),// EMPLOYEE
        companyName:"Digital Factory",
        companyAddress:"",//TODO
        companyPhone:"0895399745202",
        companyNPWP:"",
        companyId:"",//TODO
        companyTown:"Blitar",
      }

      if(!!outstandingPurchaseAds&&outstandingPurchaseAds!=="Ditolak"&&!updatedImageChache){
        //save only, sudah pernah disubmit
        //console.log("save only hasChange = "+hasChange,previewAds)
        if(!hasChange){
          setStep(prev=>prev+1);
          return
        }
        setUploading(true)
        var batch = firebase.fs.batch();

        var reviewRef = firebase.fs.doc("apps/CariIklan/review-ads/"+outstandingPurchaseAds.id)
        var purchaseRef = firebase.fs.doc("apps/CariIklan/purchases/"+outstandingPurchaseAds.id)

        let objReview={
          status:"Ditinjau",
          contentStatus:"Ditinjau",
        }
        previewAds.status="Ditinjau"
        previewAds.contentStatus="Ditinjau"
        batch.set(reviewRef, previewAds,{merge:true});
        batch.set(purchaseRef, objReview,{merge:true});

        batch.commit()
        .then(() => {
          setStep(prev=>prev+1);
          setUploading(false)
          setStatusReviewAds("Ditinjau")
        }).catch((e)=>{
          alert(e)
          setStep(2);
          setUploading(false)
        })
        
        return
      }

      //$$$ BUY $$$
      let ok=window.confirm("Publikasikan iklan "+name+" ?")
      if(!ok) return
      //save to review and purchase
      setUploading(true)

      console.log("upload image URL from pathCache "+pathCache)
      let promiseUpload=[pathCache].map(d=>new Promise((res,rej)=>{
        getFromCache(d,(response)=>{
          response.blob().then(blob=>{
            //console.log(d,blob)
            uploadImageToStorage(
              firebase,
              blob,
              pathCache,
              "photoURL",
              true,
            ).then(obj=>res(obj))
            .catch(e=>{
              console.log("Upload blob "+d.id+" error",e)
              rej(e)
            })
          })
        },(e)=>rej(e))
      }))
      

      Promise.allSettled(promiseUpload)
      .then((results) =>{
        let failCount=0
        results.forEach((result) => failCount+=result.status==="rejected"?1:0)
        if(failCount>0){
          alert("Upload gagal "+failCount+" foto\n\n"+results.map((result,i) => (i+1)+" "+ result.status +", "+result.reason+"\n"))
          setUploading(false)
          return
        }

        let downloadURL=results[0].value?.downloadURL
        let downloadThumbnailURL=results[0].value?.downloadThumbnailURL

        
        var batch = firebase.fs.batch();

        var reviewRef = firebase.fs.doc("apps/CariIklan/review-ads/"+newDocId)
        var purchaseRef = firebase.fs.doc("apps/CariIklan/purchases/"+newDocId)

        previewAds.photoURL=downloadURL
        previewAds.thumb_photoURL=downloadThumbnailURL
        previewAds.purchaseDate=(new Date()).getTime()

        purchaseAds.thumb_photoURL=downloadThumbnailURL
        
        batch.set(reviewRef, previewAds,{merge:true});
        batch.set(purchaseRef, purchaseAds,{merge:true});

        batch.commit()
        .then(() => {
          setStep(prev=>prev+1);
          setUploading(false)

          write("cariiklan.newAdsImageURL","")
          write("cariiklan.newAdsDocId","")
          deleteCache(pathCache)
          setPathCache("")
        }).catch((e)=>{
          alert(e)
          setUploading(false)
        })
      }).catch(e=>{
        alert(e)
        setUploading(false)
      })
      
    }else if(step>=3){
      window.open("https://cari-iklan.web.app/?id="+(authUser?.uid||""))
    }else{
      setStep(prev=>prev+1);
    }
  },[step,authUser,newDocId,quotaView,pricePerView,name,imageURL,pathCache,
    biaya,
    discount,
    discountValue,
    taxValue,
    totalTagihan,
    buyerName,
    buyerEmail,
    purchaseAmount,
    updatedImageChache,

    previewAds,
    firebase,
    hasChange,
    outstandingPurchaseAds])

  
  return (
    <Dialog
      open={!!open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      fullWidth
      //maxWidth="xs"
    >
      <DialogTitle>
        <IconButton
          size="small"
          style={{
            float:"right",
          }}
          disabled={uploading}
          onClick={onClose}
        >
          <CloseIcon/>
        </IconButton>
        <Typography
          component="span"
          variant={isMobile?"h5":"h4"}
        >
          {step===0?(outstandingPurchaseAds?.status?.toUpperCase()||"Pasang Iklan"):
          step===1?"Rincian Penayangan":
          step===2?"Pembayaran QRIS":"Status Transaksi"}
        </Typography>
        
      </DialogTitle>
      <DialogContent>
        
        <Collapse
          in={step===0}
          timeout={500}
        >
          <>
            <Box
              style={{
                textAlign:"center"
              }}
            >
              <label htmlFor={"icon-button-file"}>
                <input type="file" accept="image/*" id={"icon-button-file"} onChange={handlePhotoChange} disabled={!!outstandingPurchaseAds&&outstandingPurchaseAds.status==="Ditinjau"} style={{display:"none"}} />
                <img
                  style={{
                    display:"inline-block",
                    minHeight:"150px",
                    maxWidth:"300px",
                    //height:"200px",
                    //width:"200px",
                    objectFit:"cover",
                    border:"1px solid black",
                    aspectRatio:"1/1",
                    cursor:"pointer",
                    backgroundImage:"url('/static/no-image.png')",
                  }}
                  src="#"
                  alt="iklan"
                  ref={imgRef}
                  width={"90%"} 
                  height={"auto"}
                  tabIndex="0"
                />
              </label>
              <DialogContentText
                style={{
                  margin:"8px 0px",
                }}
              >
                {imageText}
              </DialogContentText>
            </Box>
            <Typography
              variant="h6"
              style={{
                textAlign:"center",
                color:"red"
              }}
            >{outstandingPurchaseAds?.denial}</Typography>
            <Collapse
              in={!!pathCache||!!outstandingReviewAds}
              timeout={500}
            >
              <>
                <TextField
                  variant="outlined"
                  label="Nama Barang/Jasa"
                  fullWidth
                  margin="dense"
                  value={name}
                  onChange={handleChangeName}
                />
                <TextField
                  variant="outlined"
                  label="Harga"
                  fullWidth
                  margin="dense"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Rp </InputAdornment>,
                  }}
                  value={price}
                  onChange={handleChangePrice}
                />
                <TextField
                  variant="outlined"
                  multiline
                  label="Keterangan singkat"
                  fullWidth
                  margin="dense"
                  value={description}
                  onChange={handleChangeDescription}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={enableMarketName}
                      onChange={handleChangeSwitchMarketName}
                      color="secondary"
                    />
                  }
                  label="Tampilkan nama toko"
                />
                <Collapse
                  in={enableMarketName}
                  timeout={500}
                >
                  <TextField
                    variant="outlined"
                    label="Nama Toko"
                    fullWidth
                    margin="dense"
                    value={marketNameValue}
                    onChange={handleChangeMarketNameValue}
                  />
                </Collapse>

                <Typography
                  style={{
                    marginTop:"16px",
                    fontWeight:"bold",
                  }}
                >Cara pembelian Barang / Jasa :</Typography>

                <FormControlLabel
                  control={
                    <Switch
                      checked={enableWhatsapp}
                      onChange={handleChangeSwitchWhatsapp}
                      color="secondary"
                    />
                  }
                  label="Hubungi Whatsapp"
                />
                <Collapse
                  in={enableWhatsapp}
                  timeout={500}
                >
                  <TextField
                    variant="outlined"
                    label="Nomor Whatsapp Penjual"
                    fullWidth
                    margin="dense"
                    placeholder="08xxxxxxxxxx"
                    type='tel'
                    value={whatsappValue}
                    onChange={handleChangeWhatsappValue}
                  />
                </Collapse>

                <FormControlLabel
                  control={
                    <Switch
                      checked={enableLink}
                      onChange={handleChangeSwitchLink}
                      color="secondary"
                    />
                  }
                  label="Link pembelian di Bukalapak / Shopee"
                />
                <Collapse
                  in={enableLink}
                  timeout={500}
                >
                  <TextField
                    variant="outlined"
                    label="Link Bukalapak / Shopee / lainnya"
                    fullWidth
                    margin="dense"
                    placeholder="https://..."
                    value={linkValue}
                    onChange={handleChangeLinkValue}
                  />
                </Collapse>
                
              </>
            </Collapse>
          </>
        </Collapse>

        <Collapse
          in={step===1}
          timeout={500}
        >
          <>
            <Typography variant="h6">Tampilan Mini</Typography>
            <Box
              style={{
                textAlign:"center",
                marginBottom:"16px",
                backgroundColor:"black",
                border:"1px solid black",
                maxHeight:"82px",
                overflowY:"hidden",
              }}
            >
              <MiniIklan
                liveAds={previewAds}
                light={true}
              />
              <MiniIklan
                liveAds={previewAds}
                light={true}
              />
              <MiniIklan
                liveAds={previewAds}
                light={true}
              />
              
            </Box>
            <Typography variant="h6">Tampilan Banner</Typography>
            <Box
              style={{
                textAlign:"center",
                marginBottom:"16px",
                border:"3px solid grey",
              }}
            >
              <BannerIklan
                ads={previewAds}
              />
            </Box>

            <Divider
              style={{
                margin:"16px 0px",
              }}
            />

            <Typography variant="h6">Permintaan</Typography>
            <TextField
              variant="outlined"
              label="Jumlah Penayangan"
              fullWidth
              margin="dense"
              required={!!ownedLiveAds}
              InputProps={{
                endAdornment: <InputAdornment position="end"> kali klik tayang</InputAdornment>,
              }}
              inputProps={{readOnly:!ownedLiveAds,min:25}}
              value={quotaView}
              onChange={handleChangeQuotaView}
            />
            <TextField
              variant="outlined"
              label="Harga tiap Klik Penayangan"
              fullWidth
              margin="dense"
              required={!!ownedLiveAds}
              InputProps={{
                startAdornment: <InputAdornment position="start">Rp </InputAdornment>,
              }}
              inputProps={{readOnly:!ownedLiveAds,min:300}}
              value={pricePerView}
              onChange={handleChangePricePerView}
            />
            <Typography variant="subtitle2">Rasio iklan Anda akan ditayangkan 1 kali terhadap 20 iklan. Harga iklan terbesar saat ini Rp 550 / klik tayang</Typography>

            <Divider
              style={{
                margin:"16px 0px",
              }}
            />

            <Typography variant="h6" style={{fontWeight:"bold"}}>Tagihan</Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
              }}
            >
              <span>Biaya : {quotaView} x Rp {pricePerView}</span>
              <span>Rp {biaya.toLocaleString("ID-id")}</span>
            </Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
                color:"green",
              }}
            >
              <span>Diskon </span>
              <span>Rp {discount.toLocaleString("ID-id")}</span>
            </Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
                fontWeight:"bold",
              }}
              variant="h6"
            >
              <span>Total Tagihan </span>
              <span>Rp {totalTagihan.toLocaleString("ID-id")}</span>
            </Typography>
                
            <Divider
              style={{
                margin:"16px 0px",
              }}
            />
          </>
        </Collapse>

        <Collapse
          in={step===2}
          timeout={500}
        >
          <>
            <Box
              style={{
                textAlign:"center"
              }}
            >
              <a href="/static/QRIS.png" target="_blank" rel="noopener noreferrer" download>
                <img
                  style={{
                    display:"inline-block",
                    minHeight:"150px",
                    maxWidth:"300px",
                    objectFit:"contain",
                    border:"1px solid black",
                    //aspectRatio:"1/1",
                  }}
                  src="/static/QRIS.png"
                  alt="QRIS Digital Factory"
                  width={"90%"} 
                  height={"auto"}
                  tabIndex="0"
                />
              </a>
            </Box>
            <Typography
              style={{
                textAlign:"center",
                //fontWeight:"bold",
              }}
              variant="subtitle2"
            >
              Total Tagihan
            </Typography>
            <Typography
              style={{
                textAlign:"center",
                fontWeight:"bold",
              }}
              variant="h4"
            >
              Rp {totalTagihan.toLocaleString("ID-id")}
            </Typography>

            <TextField
              variant="outlined"
              label="Nama Pembeli"
              fullWidth
              margin="dense"
              value={buyerName}
              disabled={!!outstandingPurchaseAds&&outstandingPurchaseAds.status!=="Ditolak"}
              onChange={handleChangeBuyerName}
            />
            <TextField
              variant="outlined"
              label="Email Pembeli"
              fullWidth
              margin="dense"
              disabled
              value={buyerEmail}
              onChange={handleChangeBuyerEmail}
            />
            <TextField
              variant="outlined"
              label="Nominal yang sudah dibayar"
              fullWidth
              margin="dense"
              InputProps={{
                startAdornment: <InputAdornment position="start">Rp </InputAdornment>,
              }}
              disabled={!!outstandingPurchaseAds&&outstandingPurchaseAds.status!=="Ditolak"}
              value={purchaseAmount}
              onChange={handleChangePurchaseAmount}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={readTos1}
                  onChange={handleChangeTOS1}
                  color="secondary"
                  disabled={!!outstandingPurchaseAds&&outstandingPurchaseAds.status!=="Ditolak"}
                />
              }
              label={<span>Telah membaca <a href="/tos#payments" target="_blank" rel="noopener noreferrer">Ketentuan Pembayaran</a></span>}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={readTos2}
                  onChange={handleChangeTOS2}
                  color="secondary"
                  disabled={!!outstandingPurchaseAds&&outstandingPurchaseAds.status!=="Ditolak"}
                />
              }
              label={<span>Telah membaca <a href="/tos#ads-contents" target="_blank" rel="noopener noreferrer">Ketentuan Konten Iklan</a></span>}
            />

          </>
        </Collapse>

        <Collapse
          in={step===3}
          timeout={500}
        >
          <>
            <Box
              style={{
                textAlign:"center",
                marginBottom:"16px",
              }}
            >
              <Typography
                style={{
                  textAlign:"center",
                  fontWeight:"bold",
                  margin:"16px 0px",
                }}
                variant="h5"
              >
                {outstandingPurchaseAds?.status?.toUpperCase()}
              </Typography>
              <label htmlFor={"uploadBuktiBayar"}>
                <input type="file" accept="image/*" id={"uploadBuktiBayar"} onChange={handleBuktiBayarChange} disabled={!outstandingPurchaseAds||outstandingPurchaseAds.status==="Ditinjau"||outstandingPurchaseAds.status==="Aktif"} style={{display:"none"}} />
                <img
                  style={{
                    display:"inline-block",
                    minHeight:"150px",
                    maxWidth:"300px",
                    //height:"200px",
                    //width:"200px",
                    objectFit:"cover",
                    border:"1px solid black",
                    aspectRatio:"1/1",
                    cursor:"pointer",
                    backgroundImage:"url('/static/no-image.png')",
                  }}
                  src="#"
                  alt="Upload Bukti Bayar"
                  ref={imgBuktiBayarRef}
                  width={"90%"} 
                  height={"auto"}
                  tabIndex="0"
                />
              </label>
              <Typography>{imageBuktiBayarText}</Typography>
            </Box>
            
            

            {/* <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
                fontWeight:"bold",
              }}
              //variant="h6"
            >
              <span>Status :</span>
              <span style={{textAlign:"right"}}>{outstandingPurchaseAds?.status}</span>
            </Typography> */}
            

            <Divider style={{margin:"16px 0px"}}/>

            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
                fontWeight:"bold",
              }}
              //variant="h6"
            >
              <span>Konten Iklan :</span>
              <span style={{textAlign:"right"}}>{outstandingPurchaseAds?.contentStatus||"Ditinjau"}</span>
            </Typography>
            <Typography
              style={{
                fontWeight:"bold",
                marginTop:"8px",
              }}
              //variant="h6"
            >
              <span>Penayangan</span>
            </Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
              }}
            >
              <span>- Mini Iklan : </span>
              <span style={{textAlign:"right"}}>Unlimited</span>
            </Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
              }}
            >
              <span>- Banner Iklan : </span>
              <span style={{textAlign:"right"}}>Unlimited</span>
            </Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
              }}
            >
              <span>- Harga / klik tayang :</span>
              <span style={{textAlign:"right"}}>Rp {pricePerView.toLocaleString("ID-id")}</span>
            </Typography>

            {/* <Divider style={{margin:"16px 0px"}}/> */}
            <Typography
              style={{
                fontWeight:"bold",
                marginTop:"8px",
              }}
              //variant="h6"
            >
              <span>Interaksi Iklan</span>
            </Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
              }}
            >
              <span>Diklik : </span>
              <span style={{textAlign:"right"}}><span style={{color:"green"}}>0</span> / {outstandingPurchaseAds?.purchasedView}</span>
            </Typography>
            <Typography
              style={{
                display:"flex",
                justifyContent:"space-between",
                marginBottom:"calc(100vh - 344px)",
              }}
            >
              <span>Dikunjungi : </span>
              <span style={{textAlign:"right",color:"green",fontWeight:"bold",fontSize:"24px"}}>0</span>
            </Typography>
          </>
        </Collapse>

        
      </DialogContent>
      <DialogActions
        style={{
          //padding:"24px 0px",
          display:step===0&&!(!!pathCache||!!outstandingReviewAds)?"none":"block",
        }}
      >
        {!isMobile?<Button
          variant="outlined"
          color="primary"
          style={{
            marginLeft:"16px",
            float:"left",
          }}
          onClick={handleClickDelete}
          startIcon={<DeleteIcon/>}
          disabled={!!outstandingReviewAds}
        >
          Batalkan
        </Button>
        :<IconButton
          color="primary"
          size="small"
          style={{
            float:"left",
            marginLeft:"8px",
          }}
          disabled={!!outstandingReviewAds}
          onClick={handleClickDelete}
        >
          <DeleteIcon/>
        </IconButton>}
        
        <Button
          variant="contained"
          color="primary"
          style={{
            margin:"0px 16px",
            float:"right",
          }}
          endIcon={step===3?<OpenInNewIcon/>:<ReceiptIcon/>}
          disabled={!enableGoToRincian||uploading}
          onClick={handleNextStep}
        >
          {step===0?"Rincian":
          step===1?"Pembayaran":
          step===2?(!!outstandingPurchaseAds?"Simpan":"Beli"):"Dashboard"}
          
        </Button>

        {!isMobile?<Button
          variant="outlined"
          color="primary"
          style={{
            marginLeft:"16px",
            float:"right",
          }}
          onClick={handlePrevStep}
          startIcon={<ChevronLeftIcon/>}
          disabled={step<=0||uploading}
        >
          Kembali
        </Button>
        :<IconButton
          color="primary"
          size="small"
          style={{
            float:"right",
          }}
          onClick={handlePrevStep}
          disabled={step<=0||uploading}
        >
          <ChevronLeftIcon/>
        </IconButton>}

      </DialogActions>
    </Dialog>
  )
})





const uploadImageToStorage = (
  firebase,
  source,
  pathStorageRef,
  fieldName,
  createThumbnail=false,
  //onFinishUpload=()=>{},
  //onErrorUpload=()=>{},
  onStartUpload=()=>{},
  onProgressUpload=()=>{},
)=>new Promise(async (resolve, reject)=>{

if(!firebase?.st||!pathStorageRef){
  //onErrorUpload("Tidak bisa upload")
  //return
  reject("Tidak bisa upload")
}

if(!pathStorageRef.endsWith("/")){
  pathStorageRef+="/"
}

var fileObj
if (source instanceof Blob){
  try{
    source.lastModifiedDate = new Date();
    source.name = fieldName;
  }catch(e){}
  
  fileObj=source
}else if (source instanceof File){
  fileObj=source
}else if(source instanceof Event){
  fileObj=source.target.files[0]
}else{
  //dataURL

  //fileObj=new File(source)
  const response = await fetch(source)
  const data = await response.blob()

  let type="image/png"
  if(source.includes(";")&&source.includes("data:")){
    let arr=source.split(";")
    if(arr[0].includes("data:")){
      type=arr[0].replace("data:","")
    }
  }
  
  const metadata = {
    type
  }
  fileObj= new File([data],source, metadata)
}

if(!fileObj){
  //onErrorUpload("Batal upload")
  //return
  reject("Batal upload")
}

if(fileObj.size>=1024*1024*10){
  //onErrorUpload("Maaf, ukuran file tidak boleh melebihi 10MB !")
  //return
  reject("Maaf, ukuran file tidak boleh melebihi 10MB !")
}

//console.log(fileObj.type)
let thumbnailURL
//thumbnail exception
if(fileObj.type==="image/gif"){
  createThumbnail=false
}
if(createThumbnail){
  //console.log("createThumbnail "+fileObj)
  try{
    thumbnailURL=await generateThumbnail(fileObj)
  }catch(err){
    //onErrorUpload(err)
    //return
    reject(err)
  }
}

//console.log("Upload "+fileObj)
onStartUpload(fileObj)

console.log("Uploading... "+(fieldName||fileObj.name)+" "+fileObj.type)//VID-20190513-WA0001.mp4 video/mp4
//var uploadTask = uploadBytesResumable(ref(getStorage(),pathStorageRef+(fieldName||fileObj.name)),fileObj)
var uploadTask = firebase.st.ref().child(pathStorageRef+(fieldName||fileObj.name)).put(fileObj);

uploadTask.on('state_changed', // or 'state_changed'
  (snapshot)=>{
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = Math.trunc((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    //console.log('Upload is ' + progress + '% done');
    switch (snapshot.state) {
      case 'paused': // or 'paused'
        console.log('Upload is paused');
        break;
      case 'running': // or 'running'
        console.log('Upload is running');
        break;
      default:
    }
    onProgressUpload(progress)
  }, (error)=> {
  //console.log('Upload error '+error.code);
  switch (error.code) {
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;

    case 'storage/unknown':
      // Unknown error occurred, inspect error.serverResponse
      break;
    default:
  }
  //onErrorUpload(error)
  reject(error)
},async ()=>{
  // Upload completed successfully, now we can get the download URL
  //console.log("on upload main completed")
  try{
    //var downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
    var downloadURL = await uploadTask.snapshot.ref.getDownloadURL()
    //console.log("downloadURL=",downloadURL)
    var downloadThumbnailURL

    //thumbnail exception
    if(fileObj.type==="image/gif"){
      downloadThumbnailURL=downloadURL
    }else 
    if(!!thumbnailURL){
      //console.log("generating thumbnailURL=",thumbnailURL)
      //var snapshotThumbnail = await uploadString(ref(getStorage(),pathStorageRef+"thumb_"+(fieldName||fileObj.name)),thumbnailURL,"data_url")
      let thumbRef=firebase.st.ref().child(pathStorageRef+"thumb_"+(fieldName||fileObj.name))
      var snapshotThumbnail = await thumbRef.putString(thumbnailURL,"data_url")
      
      //console.log("snapshotThumbnail=",snapshotThumbnail)
      //downloadThumbnailURL = await getDownloadURL(snapshotThumbnail.ref)
      downloadThumbnailURL = await snapshotThumbnail.ref.getDownloadURL()
      
      //console.log("downloadThumbnailURL=",downloadThumbnailURL)
    }
    //console.log('onFinishUpload');
    //onFinishUpload(downloadURL,downloadThumbnailURL)
    resolve({downloadURL,downloadThumbnailURL})
  }catch(error){
    //onErrorUpload(error)
    reject(error)
  }
});
})

const generateThumbnail=(imageFile)=>new Promise((resolve, reject)=>{
  if (!imageFile) {
    reject("File is null");
  }
  var reader = new FileReader();
  if (!reader) {
    reject("FileReader is null");
  }
  reader.onload = (e)=>{
    var img = document.createElement("img");
    img.onload = () => {

      var MAX_WIDTH = 200;
      var MAX_HEIGHT = 200;
      
      var width = img.width;
      var height = img.height;
      
      // Change the resizing logic
      if (width > height) {
          if (width > MAX_WIDTH) {
              height = height * (MAX_WIDTH / width);
              width = MAX_WIDTH;
          }
      } else {
          if (height > MAX_HEIGHT) {
              width = width * (MAX_HEIGHT / height);
              height = MAX_HEIGHT;
          }
      }
      
      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      // Show resized image in preview element
      var dataurl = canvas.toDataURL(imageFile.type);

      resolve(dataurl)
      //document.getElementById("preview").src = dataurl;
    }
    img.onerror = error => reject(error);
    img.src = e.target.result;
  }
  reader.onerror = error => reject(error);
  reader.readAsDataURL(imageFile);
})


export default DialogNewAds